import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
  Card,
  Link,
  CardContent,
  TextField,
  InputAdornment,
  SvgIcon,
  makeStyles
} from '@material-ui/core';
import { Search as SearchIcon } from 'react-feather';

const useStyles = makeStyles((theme) => ({
  importButton: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  sortBySelect: {
    position: 'absolute',
    float: 'right',
    right: '30px'
  }
}));

const DatatableToolbar = ({
  className,
  title,
  addButtonRoute,
  addButtonText,
  importExcelButton,
  exportExcelButton,
  onSearch,
  handleAdd,
  handleClickExportExcel,
  handleClickImportExcel,
  ...rest
}) => {
  const classes = useStyles();

  return (
    <div className={clsx(classes.root, className)} {...rest}>
      <Box className={classes.navigation} display="flex">
        <Typography color="textSecondary" variant="body2">
          <Link component={RouterLink} to="#">
            {title}
          </Link>
        </Typography>
      </Box>
      <Box display="flex" justifyContent="flex-end">
        {importExcelButton && localStorage.selectedUserHeadquarter !== 'all' ? (
          <Button
            className={classes.exportButton}
            onClick={handleClickImportExcel}
          >
            Importar Excel
          </Button>
        ) : (
          <></>
        )}
        {exportExcelButton ? (
          <Button
            className={classes.exportButton}
            onClick={handleClickExportExcel}
          >
            Exportar Excel
          </Button>
        ) : (
          <></>
        )}

        {addButtonRoute && localStorage.selectedUserHeadquarter !== 'all' ? (
          <Link component={RouterLink} to={addButtonRoute}>
            <Button color="primary" variant="contained">
              {addButtonText}
            </Button>
          </Link>
        ) : (
          addButtonText && (
            <Button
              color="primary"
              disabled={localStorage.selectedUserHeadquarter === 'all'}
              variant="contained"
              onClick={handleAdd}
            >
              {addButtonText}
            </Button>
          )
        )}
      </Box>
      <Box mt={3}>
        <Card>
          <CardContent>
            <Box maxWidth={500}>
              {onSearch && (
                <TextField
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SvgIcon fontSize="small" color="action">
                          <SearchIcon />
                        </SvgIcon>
                      </InputAdornment>
                    )
                  }}
                  placeholder="Buscar"
                  variant="outlined"
                  autoFocus="true"
                  onKeyUp={onSearch}
                />
              )}
            </Box>
          </CardContent>
        </Card>
      </Box>
    </div>
  );
};

DatatableToolbar.propTypes = {
  className: PropTypes.string,
  addButtonRoute: PropTypes.string,
  addButtonText: PropTypes.string,
  exportExcelButton: PropTypes.bool,
  handleClickAdd: PropTypes.func,
  onSearch: PropTypes.func
};

export default DatatableToolbar;
